import Vue from 'vue'
import { debounce, get } from 'lodash'
const defaultDelay = 150

Vue.directive('window-resize', {
  inserted: (element, binding) => {
    const options = { passive: true }
    const modifiers = binding.modifiers
    const delay = +get(binding, 'arg', defaultDelay)

    if (!binding.value || typeof binding.value !== 'function') {
      console.warn('window-resize should received a function as value')
      return
    }
    const callback = debounce(() => binding.value(), delay)

    element._onResize = {
      callback,
      options,
    }

    window.addEventListener('resize', callback, options)

    if (!modifiers || !modifiers.quiet) {
      callback()
    }
  },
  unbind: (element) => {
    if (!element._onResize) {
      return
    }

    const { callback, options } = element._onResize
    window.removeEventListener('window-resize', callback, options)
    delete element._onResize
  },
})
